export const unsplashAPI = {
  data() {
    return {
      apiCreds: {
        url: "https://api.unsplash.com",
        access: "V0H8ODt3AlB68xlFWj181aiZo_X7hOk7I1FlhvQKYRg",
      },
    };
  },
};
